
import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Calendar, Clock, Bell } from 'lucide-react';
import { Appointment } from '@/types/dashboard';

interface DashboardSidebarProps {
  upcomingAppointments: Appointment[];
}

export const DashboardSidebar: React.FC<DashboardSidebarProps> = ({
  upcomingAppointments
}) => {
  const formatAppointmentTime = (date: string, time: string) => {
    const today = new Date().toISOString().split('T')[0];
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const tomorrowStr = tomorrow.toISOString().split('T')[0];
    
    if (date === today) {
      return `Hoje - ${time.substring(0, 5)}`;
    } else if (date === tomorrowStr) {
      return `Amanhã - ${time.substring(0, 5)}`;
    } else {
      const appointmentDate = new Date(date);
      const day = appointmentDate.getDate().toString().padStart(2, '0');
      const month = (appointmentDate.getMonth() + 1).toString().padStart(2, '0');
      return `${day}/${month} - ${time.substring(0, 5)}`;
    }
  };
  
  return (
    <div className="w-full md:w-80 space-y-6">
      {/* Próximas Consultas */}
      <Card>
        <CardContent className="pt-6">
          <h3 className="text-lg font-medium mb-4">Próximas Consultas</h3>
          
          {upcomingAppointments.length === 0 ? (
            <p className="text-sm text-muted-foreground">
              Nenhuma consulta agendada para os próximos dias.
            </p>
          ) : (
            <div className="space-y-4">
              {upcomingAppointments.map((appointment) => (
                <div key={appointment.id} className="flex items-start gap-3">
                  <div className="bg-primary/10 p-2 rounded-full">
                    <Calendar className="h-4 w-4 text-primary" />
                  </div>
                  <div>
                    <p className="font-medium text-sm">
                      {formatAppointmentTime(appointment.date, appointment.time)}
                    </p>
                    <p className="text-sm text-muted-foreground">
                      {appointment.patientName}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
      
      {/* Ações Rápidas */}
      <Card>
        <CardContent className="pt-6">
          <h3 className="text-lg font-medium mb-4">Ações Rápidas</h3>
          
          <div className="space-y-2">
            <Button variant="outline" className="w-full justify-start">
              <Clock className="mr-2 h-4 w-4" />
              Configurar Disponibilidade
            </Button>
            <Button variant="outline" className="w-full justify-start">
              <Bell className="mr-2 h-4 w-4" />
              Gerenciar Notificações
            </Button>
          </div>
        </CardContent>
      </Card>
      
      {/* Notificações */}
      <Card>
        <CardContent className="pt-6">
          <h3 className="text-lg font-medium mb-4">Notificações</h3>
          
          <div className="space-y-4">
            <div className="border-l-2 border-primary pl-3">
              <p className="text-sm font-medium">Nova consulta agendada</p>
              <p className="text-xs text-muted-foreground">Há 2 horas</p>
            </div>
            
            <div className="border-l-2 border-muted pl-3">
              <p className="text-sm font-medium">Avaliação recebida</p>
              <p className="text-xs text-muted-foreground">Ontem</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default DashboardSidebar;
